
















export default {
    "name": "StateAnswerPublished"
    "props": {
        "context": {
            "type": Object
            "required": true
        }
        "human_created_on": String
    }
    methods:
        delete_state: ()->
            @$emit("state:delete_state")
}
